define(
  'app/views/scroll_to_anchor',['app/setup'],
  function(takhfifan) {
    takhfifan.scrollToAnchor = takhfifan.BaseView.extend({
      events: {
        'click': 'scrollTo'
      },

      scrollTo: function (event) {
        event.preventDefault();
        var $scrollToEl = $($.attr(this.el, 'href'));

        if($scrollToEl.length){
          $('html, body').animate({
            scrollTop: $scrollToEl.offset().top - 20
          }, 500);
        }
      }
    });
  });
